export const white = '#ffffff';
export const grayBorder = '#eeeeee';
export const grayText = '#858686';

export const borderStyle = `border: 1px solid ${grayBorder};`;
